import React from 'react';
import Calendar from './app/calendar';

function App() {
  return (
    <div>
     <Calendar />
    </div>
  );
}

export default App;
